import FItemString from '../FItem/String';
import component from './component.vue';

export default class FTime extends FItemString {
  __component = component;

  getMilliseconds() {
    const [hh = 0, mm = 0] = (this.value || '00:00').split(':');
    return (hh * 3600 + mm * 60) * 1000;
  }

  setMilliseconds(value) {
    const mm = Math.floor((value % 3600000) / 60000);
    const hh = Math.floor(value / 3600000);
    let val = '';
    if (mm || hh) {
      val = `${hh.toString()
        .padStart(2, '0')}:${mm.toString()
        .padStart(2, '0')}`;
    }
    this.set(val);
  }
}
